import Vue from "vue";
import {$eventBus, EVENT_SHOW_ERROR_PAGE} from "@/common/utils/event.js";

export const $showErrorPage = ({component, payload}) => {
    $eventBus.$emit(EVENT_SHOW_ERROR_PAGE, {component, payload});
};

Object.defineProperties(Vue.prototype, {
    $showErrorPage: {
        get: function () {
            return $showErrorPage;
        }
    }
});
